import {
  BulkUpdateWingDetailFormEntity,
  WingDetailEntity,
  WingEntity,
  WingResponse,
  WingsResponse,
  WriteWingDetailFormEntity,
} from 'src/types'
import { BulkUpdateWingsRequest } from 'src/types/requests/Wing'

export const WingTranslator = {
  toEntity: (response: WingResponse): WingEntity => {
    return {
      id: `${response.id}`,
      name: response.name,
      priority: response.priority,
    }
  },

  toEntities: (responses: WingResponse[]): WingEntity[] => {
    return responses.map(response => WingTranslator.toEntity(response))
  },

  toDetailEntities: (projectId: string, response: WingsResponse): WingDetailEntity[] => {
    return response.wings.map(wing => {
      return {
        id: `${wing.id}`,
        projectId,
        name: wing.name,
        priority: wing.priority,
        roomCount: wing.roomCount,
        roomTypes: wing.roomTypes.map(roomType => {
          return {
            id: `${roomType.id}`,
            name: roomType.name,
            priority: roomType.priority,
            worksRoomIds: roomType.worksRoomIds?.map(r => `${r}`) ?? [],
            compassRoomCount: roomType.compassRoomCount,
          }
        }),
      }
    })
  },

  toFormEntity: (entity: WingDetailEntity): WriteWingDetailFormEntity => {
    return {
      id: entity.id,
      entityId: entity.id,
      name: entity.name,
      roomCount: entity.roomCount,
      priority: entity.priority,
      roomTypes: entity.roomTypes.map(roomType => {
        return {
          id: roomType.id,
          entityId: roomType.id,
          name: roomType.name,
          worksRoomCount: roomType.worksRoomIds.length,
          compassRoomCount: roomType.compassRoomCount,
          priority: roomType.priority,
          isDeleted: false,
        }
      }),
      isDeleted: false,
    }
  },

  toRequest: (formEntity: BulkUpdateWingDetailFormEntity): BulkUpdateWingsRequest => {
    // まだ作成していなく（entityIdがない）削除されたものは、編集モードに移行後新たに作成しようとしたが保存前に削除したものになるため、APIに送信する必要がない
    const filteredItems = formEntity.items.filter(item => !(!item.entityId && item.isDeleted))

    return {
      wings: filteredItems.map(item => {
        return {
          id: item.entityId ? Number.parseInt(item.entityId) : undefined,
          name: item.name,
          priority: item.priority,
          roomTypes: item.roomTypes
            // まだ作成していなく（entityIdがない）削除されたものは、編集モードに移行後新たに作成しようとしたが保存前に削除したものになるため、APIに送信する必要がない
            .filter(roomType => !!roomType.entityId || !roomType.isDeleted)
            .map(roomType => {
              return {
                id: roomType.entityId ? Number.parseInt(roomType.entityId) : undefined,
                name: roomType.name,
                priority: roomType.priority,
                isDelete: roomType.isDeleted,
              }
            }),
          isDelete: item.isDeleted,
        }
      }),
    }
  },
} as const
